export default function Card({
  children,
  variant = 'default',
  padding = 'md',
  className = '',
  onClick
}) {

  // Base styles
  const baseStyles = 'rounded-lg border transition-all duration-300';

  // Variant styles
  const variants = {
    default: 'bg-card-bg dark:bg-card-bg-dark border-border dark:border text-text-primary-light dark:text-primary',
    primary: 'bg-brand-primary/10 dark:bg-brand-primary/5 border-brand-primary/20 dark:border-brand-primary/30 text-text-primary-light dark:text-primary',
    success: 'bg-success-light dark:bg-success/20 border-success dark:border-success text-text-primary-light dark:text-primary',
    danger: 'bg-danger-light dark:bg-danger/20 border-danger dark:border-danger text-text-primary-light dark:text-primary',
    warning: 'bg-warning-light dark:bg-warning/20 border-warning dark:border-warning text-text-primary-light dark:text-primary',
  };

  // Padding styles
  const paddings = {
    none: 'p-0',
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-8',
  };

  // Add cursor pointer if onClick is provided
  const cursorStyle = onClick ? 'cursor-pointer' : '';

  return (
    <div
      onClick={onClick}
      className={`${baseStyles} ${variants[variant]} ${paddings[padding]} ${cursorStyle} ${className}`}
    >
      {children}
    </div>
  );
}
